
// in hrm realstar
export const GET_ALL_AGENTS = `/employees-list`
export const GET_USER_BY_ID = `employee-detail?uid=` //={encrypt_id}
export const GET_GST = `/gst-setting`
export const GET_NATIONALITY_OPT = `/countries`

export const DECRYPTING_ID = `https://api.realstar.app/private/internal/decrypt/`
export const ENCRYPTING_ID = `https://api.realstar.app/private/internal/encrypt/`
export const GET_PROPERTY_ADDRESS = `https://api.realstar.app/private/internal/bdc_address/`
export const FILE_UPLOAD = `https://api.realstar.app/private/internal/rsuploader/`
export const GET_FILE_PATH = `https://api.realstar.app/private/uploads/submission`
 
export const GET_PAYMENT_MODE_OPT = `https://api.realstar.app/private/v2/get_mode_of_payment`

export const POST_SUBMITTED = `https://api.realstar.app/private/V2/post_submission`;

export const GET_PROPERTY_BY_POSTALCODE = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=`